import { createActions } from 'reduxsauce'
import { getHTTPClient, showNotification, checkStatusCode } from 'helpers'

export const { Types, Creators } = createActions({
    fetchConferenciaSatBegin: null,
    fetchConferenciaSatSuccess: ['postos'],
    fetchConferenciaSatFailure: ['error'],
})

export const fetchConferencia = (start, end) => dispatch => {
    dispatch(Creators.fetchConferenciaSatBegin())
    return getHTTPClient()({
        method: 'POST',
        url: '/sat',
        data: { start, end }
    })
    .then(response => dispatch(Creators.fetchConferenciaSatSuccess(response.data.postos)))
    .catch(error => {
        checkStatusCode(error.response.status)
        if (error.response) {
            showNotification(error.response.data.message, 'alert-danger')
        } else if (error.request) {
            if (process.env.NODE_ENV === 'development' )
                console.log(error.request)
            showNotification('Ops, algo deu errado, tente novamente em instantes.', 'alert-danger')
        } else {
            showNotification(error.message, 'alert-danger')
        }
        return dispatch(Creators.fetchConferenciaSatFailure(true))
    })
}